<template >
<div id="Parser26005">
    <div class="panel-container">
        <div class="panel-header">
            <div class="panel-title">{{$t(/*26005-解码*/'title.parser_26005')}}</div>
            <div class="btn-area">
                <el-button @click="handleParser" type="primary">{{$t(/*解码*/'c.parse')}}</el-button>
                <el-button @click="handleReset">{{$t(/*重置*/'c.reset')}}</el-button>
            </div>
        </div>
        <div class="panel-content">
            <el-input class="text-input" v-model="bkvText" type="textarea" :rows="4" :placeholder="$t(/*请输入*/'c.input') + 'BKV'"/>
        </div>
    </div>
    <div class="panel-container">
        <div class="panel-header">
            <div class="panel-title">{{$t(/*解码内容*/'tool.unpack_result')}}</div>
        </div>
        <div class="panel-content">
            <el-table :data="tableData" style="width: 100%">
                <el-table-column label="KEY" min-width="60">
                    <template slot-scope="{row}">{{row.cmd}}</template>
                </el-table-column>
                <el-table-column label="NAME" min-width="150">
                    <template slot-scope="{row}">{{$t(/* row.name */row.key)}}</template>
                </el-table-column>
                <template v-if="dataType === 'back'">
                    <el-table-column label="HEX_VALUE">
                        <template slot-scope="{row}">{{row.value}}</template>
                    </el-table-column>
                    <el-table-column label="VALUE">
                        <template slot-scope="{row}">
                            <div style='width: 100%;display: grid;grid-template-columns: auto auto' v-if="typeof row.content === 'object'">
                                <div style="white-space: nowrap;padding-right: 4px;" v-for="(item,i) of row.content" :key="i">
                                    {{ item.key ? $t(/* row.name */item.key) + (item.content ? ':' : '') : '' }}
                                    {{ item.content }}
                                </div>
                            </div>
                            <template v-else>{{row.content}}{{row.unit}}</template>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
        </div>
    </div>
</div>
</template>

<script>
import Core from '../../core'

import {publishFrame} from "../../core/parser/p26005";

export default {
    components: {},
    data() {
        return {
            bkvText: '',

            tableData: [],
            dataType: 'back' // send:下行  back:上行
        }
    },
    mounted() {
    },
    methods: {
        // 解码
        handleParser() {
            if (!this.bkvText) {
                return this.$message.warning(this.$t(/*请输入*/'c.input') + 'BKV');
            }
            let res = publishFrame(this.bkvText)
            console.log('handleParser res:', res)
            if (res.code !== 0) {
                return this.$message.warning(res.message);
            }
            this.tableData = Object.values(res.data)
            this.dataType = res.type
            console.log('handleParser this.tableData:', this.tableData)
        },
        // 重置
        handleReset() {
            this.bkvText = ''
            this.tableData = []
        },
    }
}
</script>

<style scoped lang="scss">
#Parser26005 {
    .panel-content  {
        padding: 20px;
    }
}
</style>
